
var wfT = window.wfI18n || function(message, values = []) { return message.replace(/\{(\d+)\}/g, (_, i) => String(values[Number(i)] ?? '')); };
var wfH = function(message, values = []) { return wfT(message, values).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c])); };
// This block requests the same featured-review data as Judge.me's Cards Carousel.
// It does not initialise that widget, so media viewers, carousels and forms stay
// on pages that actually contain a Judge.me widget. No API token is required.
const featuredProfiles = new Map([
  ['13ff536f-0766-49e6-a85e-034f2e035422', { name: 'Sarah Gonzales', position: wfT("Purchasing agent"), industry: wfT("Wellness products"), label: wfT("Wholesale buying"), order: 1 }],
  ['c982ede5-b2db-413c-87f7-156a376ed8c2', { name: 'John Peat', position: wfT("Distiller"), industry: wfT("Craft distillery"), label: wfT("Product testing"), order: 2 }],
  ['c37df0be-4e7f-4dc1-9546-cd3df42cdb52', { name: 'Justin Heikkinen', position: wfT("Owner"), industry: wfT("Craft brewery"), label: wfT("Fast turnaround"), order: 3 }],
]);

class FeaturedReviews extends HTMLElement {
  connectedCallback() {
    if (this.loaded || this.observer || this.controller) return;
    if (!('IntersectionObserver' in window)) {
      this.load();
      return;
    }
    this.observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      this.observer.disconnect();
      this.observer = null;
      this.load();
    }, { rootMargin: '600px' });
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.observer = null;
    this.controller?.abort();
    clearTimeout(this.timeout);
    this.controller = null;
  }

  async load() {
    const list = this.querySelector('[data-review-list]');
    const template = this.querySelector('[data-review-template]');
    const status = this.querySelector('[data-review-status]');
    if (!list || !template || !status || this.loaded || this.controller) return;

    const controller = new AbortController();
    this.controller = controller;
    this.timeout = setTimeout(() => controller.abort(), 12000);
    if (!list.children.length) {
      status.textContent = wfT("Loading reviews…");
      status.hidden = false;
    }

    try {
      const limit = Math.min(5, Math.max(1, Number(this.dataset.maxReviews) || 5));
      const url = new URL('https://cdn.judge.me/reviews/reviews_for_carousel');
      url.search = new URLSearchParams({
        reviews_selection: 'all',
        carousel_type: 'cards',
        star_rating: '5_star',
        custom_tags: '',
        tag_filter: 'featured',
        max_reviews: String(limit),
        url: window.location.origin,
        shop_domain: this.dataset.shopDomain,
        platform: 'shopify',
        primary_language: this.dataset.locale || 'en',
        translation_locale: this.dataset.locale || 'en',
      }).toString();

      const response = await fetch(url, { signal: controller.signal, credentials: 'omit' });
      if (!response.ok) throw new Error(`Review request failed: ${response.status}`);
      const data = await response.json();
      if (!Array.isArray(data.reviews)) throw new Error('Invalid review response');
      if (!this.isConnected || controller.signal.aborted) return;

      const seen = new Set();
      const reviews = data.reviews.filter((review) => {
        if (!review || typeof review.uuid !== 'string' || typeof review.body !== 'string' ||
            !review.body.trim() || Number(review.rating) !== 5 || seen.has(review.uuid)) return false;
        seen.add(review.uuid);
        return true;
      }).sort((a, b) => (featuredProfiles.get(a.uuid)?.order || 999) - (featuredProfiles.get(b.uuid)?.order || 999)).slice(0, limit);

      const fragment = document.createDocumentFragment();
      for (const review of reviews) {
        const card = template.content.firstElementChild.cloneNode(true);
        const profile = review.is_anonymous_reviewer ? null : featuredProfiles.get(review.uuid);
        card.dataset.reviewId = review.uuid;
        card.querySelector('[data-review-label]').textContent = profile?.label || review.title || wfT("Customer review");
        const stars = card.querySelector('[data-review-stars]');
        stars.textContent = '★★★★★';
        stars.setAttribute('aria-label', wfT("5 out of 5 stars"));
        card.querySelector('[data-review-body]').textContent =
          review.body;
        card.querySelector('[data-review-name]').textContent = review.is_anonymous_reviewer
          ? wfT("Anonymous")
          : profile?.name || review.public_reviewer_name || review.reviewer_name || wfT("Customer");
        card.querySelector('[data-review-verified]').hidden = review.verified_buyer !== true;
        const meta = card.querySelector('[data-review-meta]');
        if (profile) {
          meta.textContent = `${profile.position} · ${profile.industry}`;
          meta.hidden = false;
        }
        fragment.append(card);
      }
      // Preserve the server-rendered cards when the live data is unchanged.
      // This also avoids replacing their DOM while a customer is reading them.
      const signature = (container) => JSON.stringify(Array.from(container.children, (card) => ({
        id: card.dataset.reviewId,
        label: card.querySelector('[data-review-label]').textContent.trim(),
        body: card.querySelector('[data-review-body]').textContent.trim(),
        name: card.querySelector('[data-review-name]').textContent.trim(),
        verified: !card.querySelector('[data-review-verified]').hidden,
        meta: card.querySelector('[data-review-meta]').hidden
          ? ''
          : card.querySelector('[data-review-meta]').textContent.trim(),
      })));
      if (signature(list) !== signature(fragment)) list.replaceChildren(fragment);
      this.loaded = true;
      status.textContent = '';
      status.hidden = true;
    } catch (error) {
      if (this.isConnected && this.controller === controller && !list.children.length) {
        const archiveLink = this.querySelector('.wf-featured-reviews__link');
        status.textContent = archiveLink
          ? wfT("Reviews could not load here. Use {0} to view customer reviews.", [archiveLink.textContent])
          : wfT("Reviews could not load here. Please try again later.");
        status.hidden = false;
      }
    } finally {
      if (this.controller === controller) {
        clearTimeout(this.timeout);
        this.controller = null;
      }
    }
  }
}

if (!customElements.get('wf-featured-reviews')) {
  customElements.define('wf-featured-reviews', FeaturedReviews);
}
